import accountStyles from "../../common/css/Account.module.css";

const ContentHtmlBox = ({ children, tabIndex }) => {
    return (
        <div className={accountStyles.consent_box} tabIndex={tabIndex} dangerouslySetInnerHTML={{__html:children}}></div>
    );
};

export default ContentHtmlBox;
